
import { Font, StyleSheet, } from '@react-pdf/renderer';
const borderColor = "#DDE1E6";
export const borderThickness = 1;
export const styles = StyleSheet.create({
    table: {
        width: "auto",
        border: `${borderThickness}px solid ${borderColor}`
    },
    tableRow: {
        flexDirection: "row",
        borderBottom: `${borderThickness}px solid ${borderColor}`,
    },
    tableCol: {
        width: "50%",
        borderLeft: `${borderThickness}px solid ${borderColor}`,
    },
    text: {
        fontFamily: 'Manrope',
        fontSize: 9,
    },
    tableCell: {
        margin: "auto",
        padding: 10,
        fontSize: 10,
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 15,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
});
Font.register({
    family: 'Manrope',
    src: `${process.env.PUBLIC_URL}/static/fonts/Manrope-Medium.ttf`,
});

Font.register({
    family: 'Manrope',
    src: `${process.env.PUBLIC_URL}/static/fonts/Manrope-Bold.ttf`,
});